import React from "react";
import styled from "styled-components";

import { COLORS } from "../../../../../constants";

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 5px;
  font-weight: 600;
  font-size: 14px;
  padding: 4px 15px;
  cursor: pointer;
  border: none;
  background: none;
  color: ${COLORS.coeblue4};
  transition: border-color 0.2s;

  &:hover {
    border-color: ${COLORS.coeblue4};
  }

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`;

type ModalCancelButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export const ModalCancelButton: React.FC<ModalCancelButtonProps> = props => (
  <StyledButton type="button" {...props} />
);
